export default function DestinationsGrid() {
  const destinations = [
    {
      country: 'Pakistan',
      flag: '🇵🇰',
      image: 'https://public.readdy.ai/ai/img_res/49a13ce134bb7f5da98cb7b47de6106b.jpg',
      cities: 'Karachi, Lahore, Islamabad',
    },
    {
      country: 'India',
      flag: '🇮🇳',
      image: 'https://readdy.ai/api/search-image?query=Taj%20Mahal%20India%20iconic%20landmark%20beautiful%20architecture%20sunset%20golden%20hour%20travel%20destination%20photography%20high%20quality&width=600&height=400&seq=dest-india-001&orientation=landscape',
      cities: 'Delhi, Mumbai, Bangalore',
    },
    {
      country: 'Saudi Arabia',
      flag: '🇸🇦',
      image: 'https://readdy.ai/api/search-image?query=Masjid%20al-Haram%20Mecca%20Saudi%20Arabia%20holy%20mosque%20Kaaba%20Islamic%20architecture%20travel%20destination%20photography%20high%20quality&width=600&height=400&seq=dest-saudi-001&orientation=landscape',
      cities: 'Jeddah, Riyadh, Mecca',
    },
    {
      country: 'Africa',
      flag: '🌍',
      image: 'https://readdy.ai/api/search-image?query=African%20safari%20landscape%20wildlife%20elephants%20acacia%20trees%20sunset%20golden%20hour%20travel%20destination%20photography%20high%20quality&width=600&height=400&seq=dest-africa-001&orientation=landscape',
      cities: 'Cairo, Nairobi, Cape Town',
    },
    {
      country: 'South America',
      flag: '🌎',
      image: 'https://readdy.ai/api/search-image?query=Machu%20Picchu%20Peru%20ancient%20ruins%20mountains%20clouds%20travel%20destination%20photography%20high%20quality%20dramatic%20landscape&width=600&height=400&seq=dest-southamerica-001&orientation=landscape',
      cities: 'São Paulo, Buenos Aires, Lima',
    },
    {
      country: 'North America',
      flag: '🇺🇸',
      image: 'https://readdy.ai/api/search-image?query=New%20York%20City%20skyline%20Manhattan%20skyscrapers%20sunset%20cityscape%20travel%20destination%20photography%20high%20quality&width=600&height=400&seq=dest-northamerica-001&orientation=landscape',
      cities: 'New York, Los Angeles, Toronto',
    },
    {
      country: 'Middle East',
      flag: '🌍',
      image: 'https://readdy.ai/api/search-image?query=Dubai%20Burj%20Khalifa%20modern%20architecture%20skyline%20sunset%20UAE%20travel%20destination%20photography%20high%20quality&width=600&height=400&seq=dest-middleeast-001&orientation=landscape',
      cities: 'Dubai, Doha, Istanbul',
    },
    {
      country: 'Europe',
      flag: '🇪🇺',
      image: 'https://readdy.ai/api/search-image?query=Eiffel%20Tower%20Paris%20France%20iconic%20landmark%20sunset%20golden%20hour%20travel%20destination%20photography%20high%20quality&width=600&height=400&seq=dest-europe-001&orientation=landscape',
      cities: 'Paris, Rome, Barcelona',
    },
  ];

  const handleGetQuote = (destination: string) => {
    const message = `Hello Alwaz Travels, I would like a flight quote to ${destination}`;
    window.open(`https://wa.me/447362505895?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Top Destinations We Offer Best Airfares
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Get exclusive negotiated fares to popular destinations worldwide
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {destinations.map((destination, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={destination.image}
                  alt={destination.country}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-3xl">{destination.flag}</span>
                    <h3 className="text-2xl font-bold text-white">{destination.country}</h3>
                  </div>
                  <p className="text-sm text-white/90">{destination.cities}</p>
                </div>
              </div>
              <div className="p-4">
                <button
                  onClick={() => handleGetQuote(destination.country)}
                  className="w-full bg-[#14B8A6] text-white py-3 rounded-lg font-semibold hover:bg-[#0F9688] transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  Get Fare Quote
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
